import s from "../LogoList.module.scss";

const Logo = ({ logo }) => (
  <div className={s.logo}>
    <div className={s.logoInner}>{logo}</div>
  </div>
);

export default Logo;
